import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import NsxMarketingConsent from '@britishgasenergy/react-nucleus/dist/nuc-components/NsxMarketingConsent';
import NsContent from 'components/common/ns-content/NsContent';

import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import {
  setMarketingPreferences,
  selectMarketingPreferences
} from 'state/user-preferences/user-preferences-slice';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { MeterReadPreferences } from 'components/direct-sales/user-preferences/components/MeterReadPreferences';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'userPreferencesTestId';

export const UserPreferences = () => {
  const dispatch = useDispatch();
  const marketingPreferences = useSelector(
    selectMarketingPreferences,
    shallowEqual
  );
  const { next, eventTypes } = useNavigation();

  const handleGoNext = useCallback(
    (event, formData) => {
      const formValue = formData.fieldsByName['marketing-consent'].value;
      const formValuesArr = formValue ? formValue.split(',') : [];
      const marketingPrefs = Object.keys(marketingPreferences).reduce(
        (acc, key) => {
          return {
            ...acc,
            [key]: formValuesArr.includes(key)
          };
        },
        {}
      );
      dispatch(setMarketingPreferences(marketingPrefs));
      next({ eventType: eventTypes.NEXT });
    },
    [next, eventTypes, marketingPreferences, dispatch]
  );

  return useMemo(
    () => (
      <NsPanel testId={testId}>
        <NsBackCta />
        <NsContent>
          <NsTitle title="Tell us about your preferences" />
        </NsContent>
        <NsForm onSubmit={handleGoNext}>
          <NsxMarketingConsent>
            <h2 slot="heading">Get the latest news and special offers</h2>
          </NsxMarketingConsent>
          <MeterReadPreferences />
          <NsPrimaryCta>Continue</NsPrimaryCta>
        </NsForm>
      </NsPanel>
    ),
    [handleGoNext]
  );
};

export default UserPreferences;
